import { Component } from "react"
import PropTypes from "prop-types"
import { map, isEmpty, chain, capitalize } from "lodash"
import { Card, List, ListItem, ListSubheader } from "@mui/material"
import { getRuleGroup } from "modules/smart-trade-rule-search/helpers"
import Rule from "./rule"
import "./styles.scss"
import { SMART_TRADE_RULE } from "helpers/shapes"

export default class SmartTradeRulesPanel extends Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
    smartTradeRulesSearchResults: PropTypes.array,
    smartTradeRulesSearch: PropTypes.func.isRequired,
    smartTradeRulesSearchValue: PropTypes.string,
    setSmartTradeRule: PropTypes.func.isRequired,
    removeSmartTradeRule: PropTypes.func.isRequired,
    smartTradeRules: PropTypes.arrayOf(SMART_TRADE_RULE),
    selectedDate: PropTypes.string.isRequired,
    currentSmartTradeValues: PropTypes.object,
    smartLabel: PropTypes.string,
  }

  onRemoveSmartTradeRule = (item) => {
    const { removeSmartTradeRule } = this.props
    removeSmartTradeRule(item)
  }

  rules = () => {
    const { smartTradeRules, currentSmartTradeValues, setSmartTradeRule, isReadOnly, smartLabel } = this.props

    return chain(smartTradeRules)
      .groupBy(getRuleGroup)
      .map((group, groupId) => (<List key={groupId} className="rule-group">
        <ListSubheader disableSticky className="rule-listheader">{capitalize(groupId)}</ListSubheader>
        {map(group, rule => <ListItem key={`${rule.type}-${rule.category}-${rule.id}`} className="rule-listitem">
          <Rule
            rule={rule}
            removeSmartTradeRule={this.onRemoveSmartTradeRule}
            updateSmartTradeRule={setSmartTradeRule}
            currentSmartTradeValues={currentSmartTradeValues}
            isReadOnly={isReadOnly}
            currentValue={rule.getter && rule.getter(currentSmartTradeValues)}
            smartLabel={smartLabel}
          />
        </ListItem>)}
      </List>))
      .value()
  }

  render() {
    const { isReadOnly, smartTradeRules } = this.props
    const noRulesMsg = isReadOnly ? "No smart trade rule set for this experiment" : "No rules have been added"

    return <div className="component_smart-trade-rules-panel">
      {isEmpty(smartTradeRules)
        ? <span>{noRulesMsg}</span>
        : <Card square className="card-smart-trade-rules-panel">
          <div className="panel-row">
            {this.rules()}
          </div>
        </Card>}
    </div>
  }
}
